import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { withTheme } from 'glamorous';
import withQuery from '../../../../../common/components/withQuery';
import { Card, CardActions, CardText } from 'react-toolbox/lib/card';
import DataTable from '../../../../../common/components/DataTable';
import { getDisplayPrice } from '../../../../../common/utils/format-currency';
import {
  genericObjectSort,
  SortProperty,
} from '../../../../../common/utils/object-sort';
import { LOCATION_ORIGIN } from '../../../../../common/call-api';
import tableTheme from '../tableTheme.css';
import {
  TitleBar,
  DocTitle,
} from '../../../../../common/components/Layout/StandardPageTemplate/Context';
import { isEventNational } from '../../../utils';
import LocationBlock from '../../../components/LocationBlock';
import { registrationApi } from '../../../actions/registration';
import styles from './Confirmation.css';
import {Button} from '../../../../../common/components';

class ConfirmationView extends React.Component {
  state = {
    registrationDetails: undefined,
  };

  componentWillMount() {
    this.loadRegistrationDetails(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.registrationDetails) {
      this.loadRegistrationDetails(nextProps);
    }
  }

  loadRegistrationDetails(props) {
    const { location, match: { params }, currentUser } = props;
    const { cst } = location.query || {};
    const { eventId: eventKey } = params;
    const individualKey = currentUser.id || cst;
    if (individualKey && eventKey) {
      registrationApi
        .get(null, {
          params: {
            eventKey,
            individualKey,
          },
        })
        .then(({ resp, json }) => {
          let details = {};
          if (resp.ok) {
            details = json;
          }

          this.setState({
            registrationDetails: details,
          });
        });
    }
  }

  buildData = () => {
    const { event = {} } = this.props;
    const { registrationDetails = {} } = this.state;
    const registrationPrice =
      !event.isFree && event.pricing
        ? event.pricing.find(
            price => price.key === registrationDetails.priceKey
          )
        : {};
    const data = [
      { key: 'event-name', label: 'Event Name', value: event.title, sort: 11 },
      {
        key: 'event-date',
        label: 'Event Date',
        value: event.displayDate,
        sort: 12,
      },
    ];
    if (event.isRemote === false) {
      data.push({
        key: 'user-name',
        label: 'Badge Name',
        value: registrationDetails.registrantBadgeName,
        sort: 21,
      });
    }
    if (event.location && Object.keys(event.location).length > 1) {
      data.push({
        key: 'event-location',
        label: 'Event Location',
        sort: 13,
        value: () => (
          <LocationBlock
            location={event.location}
            isRemote={event.isRemote}
            color={this.props.theme.color}
            showIcon={false}
          />
        ),
      });
    }
    if (registrationDetails.transactionDate) {
      data.push({
        key: 'reg-date',
        label: 'Registration Date',
        value: moment(registrationDetails.transactionDate).format('MM/DD/YYYY'),
        sort: 2,
      });
    }
    if (registrationDetails.confirmationNumber) {
      data.push({
        key: 'confirmation-code',
        label: 'Confirmation #',
        value: registrationDetails.confirmationNumber,
        sort: 1,
      });
    }
    if (
      registrationDetails.guestBadgeNames &&
      registrationDetails.guestBadgeNames.length
    ) {
      const displayGuests = registrationDetails.guestBadgeNames.filter(
        guestName => {
          const charArray = [...guestName];
          return charArray.every(char => isNaN(parseInt(char, 10)));
        }
      );
      if (displayGuests.length) {
        data.push({
          key: 'guest-name',
          label:
            registrationPrice && registrationPrice.isTable
              ? 'Table Guests'
              : 'Guest Names',
          value: displayGuests.join(', '),
          sort: 23,
        });
      }
    }
    // display table name if a table was purchased
    if (registrationPrice && registrationPrice.isTable) {
      data.push({
        key: 'table-name',
        label: 'Table Name',
        value: registrationPrice.tableName,
        sort: 22,
      });
    }
    if (registrationDetails.payment) {
      const payment = registrationDetails.payment;
      if (payment.amount) {
        data.push({
          key: 'payment-amount',
          label: 'Payment Amount',
          value: getDisplayPrice(payment.amount),
          sort: 31,
        });
      }
      if (payment.paymentType) {
        data.push({
          key: 'payment-type',
          label: 'Payment Type',
          value: payment.paymentType,
          sort: 32,
        });
      }
      if (payment.creditCardNumber) {
        data.push({
          key: 'payment-cardlastfour',
          label: 'Credit Card Last 4',
          value: payment.creditCardNumber.substr(
            payment.creditCardNumber.length - 4
          ),
          sort: 33,
        });
      }
    }
    return data.sort(genericObjectSort(new SortProperty('sort')));
  };

  formatAddress = location => {
    if (Object.keys(location).length === 1) {
      return '';
    }
    const address = [];
    if (location.name) {
      address.push(location.name);
    }
    if (location.addressLine1) {
      address.push(location.addressLine1);
    }
    if (location.addressLine2) {
      address.push(`${location.addressLine2} `);
    }
    if (location.city) {
      address.push(`${location.city},`);
    }
    if (location.state) {
      address.push(location.state);
    }
    if (location.postalCode) {
      address.push(location.postalCode);
    }
    return address.join(' ');
  };
  render() {
    const { event, currentUser } = this.props;
    const isNational = isEventNational(event);
    const buttonColor = { primary: isNational, accent: !isNational };
    return (
      <div>
        <DocTitle title="Confirmation | Detail | Events | NFIB" />
        <TitleBar title="Event Confirmation" />
        <div className={styles.container}>
          <Card>
            <CardText>
              <DataTable
                theme={tableTheme}
                className={classnames(styles.table, {
                  [styles.national]: isNational,
                  [styles.state]: !isNational,
                })}
                renderHeader={() => (
                  <thead className={tableTheme.thead}>
                    <tr className={tableTheme.row}>
                      <th colSpan={2} className={tableTheme.cellHeading}>
                        Registration Details
                      </th>
                    </tr>
                  </thead>
                )}
                columnDefinitions={{
                  label: { render: colValue => <b>{colValue}</b> },
                  value: { render: colValue => <span>{colValue}</span> },
                }}
                data={this.buildData()}
              />
            </CardText>
            <CardActions className={styles.actions}>
              <Button
                to={`/events/${event.key}`}
                label="Event Details"
                className={styles.button}
              />
              <form
                id="calendarForm"
                action={`/events/${event.key}/confirmation/calendar`}
                method="post"
                encType="application/x-www-form-urlencoded"
                className={styles.button}
              >
                <input
                  type="hidden"
                  value={`${LOCATION_ORIGIN}/events/${event.key}/confirmation?cst=${currentUser.id}`}
                  name="confirmationUrl"
                />
                <input
                  type="hidden"
                  value={`[NFIB Event] ${event.title}`}
                  name="eventTitle"
                />
                <input
                  type="hidden"
                  value={moment(event.startDate)
                    .utc()
                    .format('YYYYMMDD[T]HHmmss[Z]')}
                  name="eventStart"
                />
                <input
                  type="hidden"
                  value={moment(event.endDate)
                    .utc()
                    .format('YYYYMMDD[T]HHmmss[Z]')}
                  name="eventEnd"
                />
                <input
                  type="hidden"
                  value={event.shortDescription}
                  name="eventShortDescription"
                />
                <input
                  type="hidden"
                  value={this.formatAddress(event.location)}
                  name="eventLocation"
                />
                <Button
                  type="submit"
                  label="add to calendar"
                  buttonType="text"
                  {...buttonColor}
                  style={{ width: '100%', margin: '0' }}
                />
              </form>
            </CardActions>
          </Card>
        </div>
      </div>
    );
  }
}

export default withQuery(withTheme(ConfirmationView));



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/Confirmation/index.js